import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	jsmAssetsReports: {
		id: 'navigation-apps-sidebar-nav4-sidebars-content-assets.common.reports.jsm-assets-reports',
		defaultMessage: 'Reports',
		description: 'Assets dropdown item to link customer to Reports page.',
	},
});
